/* Disciple Project v2 — small site-wide behaviour (loaded by snippets/dsp-chrome-head.liquid).
   1. Homepage offer (sections/dsp-offer.liquid): the size buttons set the form's variant id, the price and the
      button state ("Add to cart" / "Sold out") from the variant's own data.
   2. Sticky add-to-cart on phones (snippets/dsp-sticky-atc.liquid): shows when the page's main Add to cart button
      has scrolled out of view; its button clicks that real button, so the chosen size, Dawn's cart drawer and every
      error message stay Dawn's own. It mirrors the real button's label + disabled state. */
(() => {
  if (window.DSPChrome) return;

  function initOffer(root) {
    const sizes = root.querySelector('[data-dsp-sizes]');
    if (!sizes || sizes.dataset.bound) return;
    sizes.dataset.bound = '1';
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const idInput = form && form.querySelector('input[name="id"]');
    const btn = root.querySelector('[data-dsp-atc]');
    const label = btn && btn.querySelector('span');
    const price = root.querySelector('[data-dsp-price]');
    const strings = window.variantStrings || { addToCart: 'Add to cart', soldOut: 'Sold out' };
    sizes.addEventListener('change', e => {
      const r = e.target;
      if (!r.matches('input[type="radio"]')) return;
      if (idInput) { idInput.value = r.value; idInput.disabled = false; }
      if (price && r.dataset.price) price.textContent = r.dataset.price;
      const ok = r.dataset.available === 'true';
      if (btn) {
        btn.disabled = !ok;
        btn.toggleAttribute('aria-disabled', false);
        if (label) label.textContent = ok ? strings.addToCart : strings.soldOut;
      }
    });
  }

  function initSticky(bar) {
    if (bar.dataset.bound) return;
    bar.dataset.bound = '1';
    const target = document.getElementById(bar.dataset.target);
    const btn = bar.querySelector('.dsp-sticky-atc__btn');
    if (!target || !btn) { bar.remove(); return; }
    const sync = () => {
      const t = target.querySelector('span');
      btn.textContent = (t ? t.textContent : target.textContent).trim();
      btn.disabled = target.disabled || target.getAttribute('aria-disabled') === 'true';
    };
    sync();
    new MutationObserver(sync).observe(target, { attributes: true, childList: true, subtree: true, characterData: true });
    btn.addEventListener('click', () => {
      const live = document.getElementById(bar.dataset.target) || target; // Dawn may re-render the button on a variant change
      if (!btn.disabled) live.click();
    });
    document.addEventListener('change', () => setTimeout(sync, 400));
    let mainVisible = true, footerVisible = false;
    const update = () => {
      const show = !mainVisible && !footerVisible;
      bar.classList.toggle('is-shown', show);
      bar.inert = !show;
      bar.setAttribute('aria-hidden', String(!show));
    };
    new IntersectionObserver(([en]) => { mainVisible = en.isIntersecting || en.boundingClientRect.top > window.innerHeight; update(); })
      .observe(target);
    const foot = document.querySelector('.footer');
    if (foot) new IntersectionObserver(([en]) => { footerVisible = en.isIntersecting; update(); }).observe(foot);
    update();
  }

  // 3. No links under the product (Conner 2026-10-09): Shopify's checkout script injects a "More payment options" link
  //    next to Shop Pay in the browser (it is not in the Liquid output), so it is removed here as soon as it appears.
  const MORE = 'more-payment-options-link, .shopify-payment-button__more-options';
  function stripMore(box) {
    if (box.dataset.dspStrip) return;
    box.dataset.dspStrip = '1';
    const strip = () => box.querySelectorAll(MORE).forEach(el => el.remove());
    strip();
    new MutationObserver(strip).observe(box, { childList: true, subtree: true });
  }

  const initAll = scope => {
    scope.querySelectorAll('.shopify-payment-button').forEach(stripMore);
    scope.querySelectorAll('.dsp-offer').forEach(initOffer);
    scope.querySelectorAll('[data-dsp-sticky]').forEach(initSticky);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);
  document.addEventListener('shopify:section:load', e => initAll(e.target));
  window.DSPChrome = { initAll };
})();
